import { BaseToast, ErrorToast } from 'react-native-toast-message'
import type { BaseToastProps } from 'react-native-toast-message'

const toastConfig = {
	success: (props: BaseToastProps) => (
		<BaseToast
			{...props}
			style={{
				width: '100%',
				borderLeftColor: '#B5F6AE',
				borderRadius: 0,
				height: 80,
			}}
			contentContainerStyle={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: '#B5F6AE',
			}}
			text1Style={{
				textAlign: 'center',
				fontSize: 18,
				color: '#106A5C',
				fontFamily: 'Apercu-Medium',
			}}
			text2Style={{
				textAlign: 'center',
				fontSize: 14,
				color: '#106A5C',
				fontFamily: 'Apercu-Medium',
			}}
			text2NumberOfLines={3}
		/>
	),
	error: (props: BaseToastProps) => (
		<ErrorToast
			{...props}
			style={{
				width: '100%',
				borderLeftColor: '#FB8177',
				borderRadius: 0,
				height: 80,
			}}
			contentContainerStyle={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: '#FB8177',
			}}
			text1Style={{
				textAlign: 'center',
				fontSize: 16,
				color: '#FFFFFF',
				fontFamily: 'Apercu-Medium',
			}}
			text2Style={{
				textAlign: 'center',
				fontSize: 14,
				color: '#FFFFFF',
				fontFamily: 'Apercu-Medium',
			}}
			text1NumberOfLines={3}
			text2NumberOfLines={3}
		/>
	),
}

export default toastConfig
